import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Link,
    type SxProps,
} from "@mui/material";
import Button from "@mui/material/Button";
import * as React from "react";
import {useMemo} from "react";
import sanitizeHtml from "sanitize-html";
import type {Fee} from "@/types/Fee.ts";

type ViewMoreFee = Pick<Fee, "description" | "name">;

type Props = {
    fee: ViewMoreFee;
    sx?: SxProps;
};

const ViewMoreModalLink = ({fee, sx}: Props) => {
    const [open, setOpen] = React.useState(false);
    const handleClose = () => setOpen(false);
    const description = useMemo(() => {
        return sanitizeHtml(fee.description);
    }, [fee.description]);

    return (
        <>
            <Link href="#" onClick={() => setOpen(true)} underline="none" sx={sx}>
                View More...
            </Link>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-name"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-name">{fee.name}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <div dangerouslySetInnerHTML={{__html: description}} />
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} autoFocus>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default ViewMoreModalLink;
